export default {
  pages: [],
  page: null,
  error: false,
  errorMessage: "",
  successMessage: "",
  success: false,
};
